/**
 * issue #60: 選択ページ集合 (Set<number>, 1-origin) と number[][] レンジの相互変換。
 * pageRange API 契約 (int[][]) と サムネイル選択 UI (Set) の橋渡し。
 */
export function pageSetToRanges(pages: Set<number>): number[][] {
  const sorted = Array.from(pages).sort((a, b) => a - b);
  const ranges: number[][] = [];
  for (const p of sorted) {
    const last = ranges[ranges.length - 1];
    if (last && p === last[1] + 1) {
      last[1] = p;
    } else {
      ranges.push([p, p]);
    }
  }
  return ranges;
}

export function rangesToPageSet(ranges: number[][]): Set<number> {
  const set = new Set<number>();
  for (const [start, end] of ranges) {
    for (let p = start; p <= end; p++) set.add(p);
  }
  return set;
}
